import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SelectIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.88 16.44H18.24V5.72H7.52V4.08H19.88V16.44ZM4.12 19.84V7.48H16.48V19.84H4.12ZM5.76 18.2H14.84V9.12H5.76V18.2Z" />
    </SvgIcon>
  );
});
